import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AppInitComponent } from './app-init/app-init.component';

@Component({
    selector: 'skl-app',
    template: `
        <skl-app-init />
        <router-outlet></router-outlet>
    `,
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [RouterOutlet, AppInitComponent]
})
export class AppComponent {}
